import type { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

export function StatCard({
  icon: Icon,
  label,
  value,
  hint,
  loading,
  tone,
}: {
  icon: LucideIcon;
  label: string;
  value?: string | number;
  hint?: string;
  loading?: boolean;
  tone?: 'default' | 'success' | 'destructive';
}) {
  return (
    <Card>
      <CardContent className="flex items-start gap-3 p-5">
        <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
          <Icon className="size-5" />
        </div>
        <div className="min-w-0">
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            {label}
          </p>
          {loading ? (
            <Skeleton className="mt-1 h-7 w-24" />
          ) : (
            <p
              className={cn(
                'truncate font-semibold tabular-nums',
                String(value ?? '').length > 12 ? 'text-lg xl:text-xl' : 'text-2xl',
                tone === 'success' && 'text-green-700 dark:text-green-300',
                tone === 'destructive' && 'text-destructive',
              )}
              title={typeof value === 'string' ? value : undefined}
            >
              {value ?? '—'}
            </p>
          )}
          {hint && <p className="truncate text-xs text-muted-foreground">{hint}</p>}
        </div>
      </CardContent>
    </Card>
  );
}
